import type { LabelHTMLAttributes, ReactNode } from 'react';

export function Label({
  children,
  ...rest
}: LabelHTMLAttributes<HTMLLabelElement> & { children: ReactNode }) {
  return (
    <label className="ds-label" {...rest}>
      {children}
    </label>
  );
}
